import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defineComponent, watch, reactive, ref, computed, onMounted, onBeforeUnmount, resolveComponent, openBlock, createElementBlock, normalizeClass, unref, createVNode, createCommentVNode, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps, createElementVNode, createBlock, resolveDynamicComponent } from 'vue';
import { useStyleConfig } from '../abstract';
import TabsViewHead from './TabsViewHead.js';
import EmptyPage from './EmptyPage.js';
import TabsKeepAlive from './AKeepAlive';
import Contextmenu from '../contextmenu';
import { message } from 'ant-design-vue';
import { getSessionItem, removeSessionItem, setSessionItem } from '../utils/storage';
import { VerticalRightOutlined, VerticalLeftOutlined, CloseOutlined, SyncOutlined } from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
var _hoisted_1 = {
  key: 1
};
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'TabsView',
  props: {
    useCache: {
      type: Boolean,
      default: true
    },
    basePath: {
      type: String,
      default: '/tabs-view-empty'
    },
    affix: {
      type: Boolean,
      default: undefined
    },
    lastTabClosable: Boolean
  },
  emits: ["update:affix"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useStyleConfig = useStyleConfig('tabs-view'),
      prefixCls = _useStyleConfig.prefixCls;
    var route = useRoute();
    var router = useRouter();
    if (!router.hasRoute('TabsViewEmptyPage')) {
      router.addRoute({
        path: '/tabs-view-empty',
        name: 'TabsViewEmptyPage',
        component: EmptyPage,
        meta: {
          renderMenu: false
        }
      });
    }
    watch(route, function (val) {
      addTab(val);
    });
    var clearKeys = reactive([]);
    var excludeKeys = reactive([]);
    var current = ref(null);
    var reloading = ref(false);
    var tabList = reactive([]);
    var tabsConfig = reactive({});
    var visible = ref(false);
    var contextItem = ref();
    var sAffix = ref(true);
    var contextList = [{
      key: 'right',
      title: '关闭右侧',
      icon: VerticalRightOutlined
    }, {
      key: 'left',
      title: '关闭左侧',
      icon: VerticalLeftOutlined
    }, {
      key: 'others',
      title: '关闭其它',
      icon: CloseOutlined
    }, {
      key: 'refresh',
      title: '刷新页面',
      icon: SyncOutlined
    }];
    var lock = computed({
      set: function set(val) {
        sAffix.value = val;
        emit('update:affix', val);
      },
      get: function get() {
        var _props$affix;
        return (_props$affix = props.affix) !== null && _props$affix !== void 0 ? _props$affix : sAffix.value;
      }
    });
    var currTab = computed(function () {
      return tabList.find(function (item) {
        return item.key === current.value;
      });
    });
    function loadRoutesConfig(routes) {
      var parentCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      routes.forEach(function (route) {
        var _route$meta = route.meta,
          meta = _route$meta === void 0 ? {} : _route$meta;
        var _meta$cacheable = meta.cacheable,
          cacheable = _meta$cacheable === void 0 ? parentCache : _meta$cacheable;
        if (!cacheable) {
          excludeKeys.push(new RegExp("".concat(route.path, "$")));
        }
        if (route.children && route.children.length > 0) {
          loadRoutesConfig(route.children, cacheable);
        }
      });
    }
    var sessionCacheKey = computed(function () {
      return prefixCls.value + '-session';
    });
    /**
     * 加载 session 配置
     */
    function loadSessionConfig() {
      var cachedTabs = getSessionItem(sessionCacheKey.value);
      if (cachedTabs && cachedTabs.length > 0) {
        if (window['clearTabs'] !== undefined) {
          cachedTabs = cachedTabs.filter(function (item) {
            return window['clearTabs'].indexOf(item.key) === -1;
          });
          window['clearTabs'].splice(0);
        }
        tabList.push.apply(tabList, _toConsumableArray(cachedTabs));
        tabList.forEach(function (tab) {
          if (tabsConfig[tab.key]) {
            tab.loading = tabsConfig[tab.key].loading;
          }
        });
      }
      removeSessionItem(sessionCacheKey.value);
    }
    /**
     * 关闭事件监听器
     */
    function closeListener(event) {
      var _event$detail;
      var _ref2 = (_event$detail = event.detail) !== null && _event$detail !== void 0 ? _event$detail : {},
        close = _ref2.close,
        next = _ref2.next;
      var fullPath = getFullPath(close);
      var index = tabList.findIndex(function (item) {
        return item.fullPath === fullPath;
      });
      if (index !== -1) {
        closeTab(fullPath, next);
      } else {
        console.error("\u672A\u627E\u5230\u4E0E`".concat(fullPath, "`\u5339\u914D\u7684\u9875\u7B7E"));
      }
    }
    /**
     * 刷新事件监听器
     */
    function refreshListener(event) {
      var _event$detail2;
      var _ref3 = (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 ? _event$detail2 : {},
        route = _ref3.route;
      var fullPath = getFullPath(route);
      refresh(fullPath);
    }
    /**
     * 打开页签事件监听器
     */
    function openPageListener(event) {
      var _event$detail3;
      var _ref4 = (_event$detail3 = event.detail) !== null && _event$detail3 !== void 0 ? _event$detail3 : {},
        route = _ref4.route,
        _ref4$options = _ref4.options,
        options = _ref4$options === void 0 ? {} : _ref4$options;
      var title = options.title,
        position = options.position,
        _options$replace = options.replace,
        replace = _options$replace === void 0 ? false : _options$replace,
        view = options.view,
        target = options.target;
      var fullPath = getFullPath(route);
      setTitle(fullPath, title);
      setPositionConfig(fullPath, position, replace);
      var rawRoute = typeof route === 'string' ? {
        path: route,
        query: {
          _to_view: view
        }
      } : _objectSpread(_objectSpread({}, route), {}, {
        query: _objectSpread(_objectSpread({}, route.query), {}, {
          _to_view: view
        })
      });
      if (target === '_blank') {
        window.open(router.resolve(rawRoute).href, '_blank');
      } else {
        router.push(rawRoute);
      }
    }
    var getRouteFullPath = function getRouteFullPath(route) {
      if (typeof route === 'string') return route;
      return router.resolve(route).fullPath;
    };
    /**
     * 关闭页签
     * @param key
     * @param nextRoute
     */
    // eslint-disable-next-line complexity
    function closeTab(fullPath, nextRoute) {
      if (tabList.length === 1 && !props.lastTabClosable) {
        message.warn('这是最后一个页面了，不允许关闭');
        return;
      }
      // 解析要跳转的路由
      var nextPath = nextRoute && getRouteFullPath(nextRoute);
      if (nextPath === fullPath && fullPath === current.value) {
        // message.warning('关闭页签和跳转页签相同，请直接使用刷新API或跳转API');
        return;
      }
      var index = tabList.findIndex(function (item) {
        return item.fullPath === fullPath;
      });
      if (index === -1) {
        console.error("");
      }
      var tab = tabList[index];
      if (tab && !(tab !== null && tab !== void 0 && tab.closeable)) {
        message.warning('此页签不允许关闭');
        return;
      }
      closeByIndex(index);
      // 跳转下个页签
      if (nextPath) {
        router.push(nextRoute);
      } else {
        openOnClose(fullPath, index);
      }
    }
    /**
     * 关闭当前页签后自动开启新页签
     * @param closedPath
     * @param closedIndex
     */
    function openOnClose(closedPath, closedIndex) {
      if (tabList.length > 0 && closedPath === current.value) {
        var nextIndex = closedIndex >= tabList.length ? tabList.length - 1 : closedIndex;
        router.push(tabList[nextIndex].fullPath);
      } else if (tabList.length === 0) {
        router.push(props.basePath);
      }
    }
    /**
     * 根据页签位置关闭页签
     */
    function closeByIndex(index) {
      var clearTabs = tabList.splice(index, 1);
      if (clearTabs[0].cacheable) {
        clearKeys.splice.apply(clearKeys, [0, clearKeys.length].concat(_toConsumableArray(clearTabs.map(function (item) {
          return item.fullPath;
        }))));
      }
    }
    /**
     * 刷新内容
     */
    function refresh(fullPath) {
      var tab = tabList.find(function (item) {
        return item.fullPath === fullPath;
      });
      if (tab) {
        tab.loading = true;
        clearKeys.push(tab.key);
        if (current.value === fullPath) {
          reloadContent().then(function () {
            tab.loading = false;
          });
        } else {
          setTimeout(function () {
            tab.loading = false;
          }, 250);
        }
      }
    }
    /**
     * 重新加载内容
     */
    function reloadContent(_x) {
      return _reloadContent.apply(this, arguments);
    }
    function _reloadContent() {
      _reloadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tab) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reloading.value = true;
                return _context.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    reloading.value = false;
                    resolve(undefined);
                  }, 250);
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _reloadContent.apply(this, arguments);
    }
    var listenerConfig = {
      'page:close': closeListener,
      'page:refresh': refreshListener,
      'page:open': openPageListener,
      'page:config': configPageListener,
      'page:loading': pageLoadingListener,
      'page:closeAll': pageCloseAllListener,
      'page:closeOthers': pageCloseOthersListener,
      unload: unloadListener
    };
    /**
     * 添加页签，检查页签存放位置
     */
    function pushTab(tab) {
      var _tabsConfig$tab$fullP;
      var config = (_tabsConfig$tab$fullP = tabsConfig[tab.fullPath]) !== null && _tabsConfig$tab$fullP !== void 0 ? _tabsConfig$tab$fullP : {};
      var _config$position = config.position,
        position = _config$position === void 0 ? tabList.length : _config$position,
        _config$replace = config.replace,
        replace = _config$replace === void 0 ? false : _config$replace;
      if (replace && position < tabList.length) {
        closeByIndex(position);
      }
      tabList.splice(position, 0, tab);
      tabsConfig[tab.fullPath] && delete tabsConfig[tab.fullPath]['position'] && delete tabsConfig[tab.fullPath]['replace'];
    }
    /**
     * 重设页签位置
     */
    function resetTabPosition(tab) {
      var _tabsConfig$tab$fullP2;
      var config = (_tabsConfig$tab$fullP2 = tabsConfig[tab.fullPath]) !== null && _tabsConfig$tab$fullP2 !== void 0 ? _tabsConfig$tab$fullP2 : {};
      var position = config.position,
        _config$replace2 = config.replace,
        replace = _config$replace2 === void 0 ? false : _config$replace2;
      if (position !== undefined) {
        var before = tabList.findIndex(function (item) {
          return item.fullPath === tab.fullPath;
        });
        if (before !== position) {
          if (replace && position < tabList.length) {
            closeByIndex(position);
            tabList.splice(position, 0, tab);
            tabList.splice(before, 1);
          } else {
            tabList.splice(before, 1);
            tabList.splice(position, 0, tab);
          }
        }
        delete tabsConfig[tab.fullPath]['position'];
        delete tabsConfig[tab.fullPath]['replace'];
      }
    }
    /**
     * 设置页签位置
     * @param fullPath
     * @param position
     * @param replace
     */
    function setPositionConfig(fullPath, position, replace) {
      var index = getPositionIndex(position);
      var target = {};
      var source = tabsConfig[fullPath];
      _extends(target, source, {
        position: index,
        replace: replace
      });
      tabsConfig[fullPath] = target;
    }
    /**
     * 创建新标签
     * @param route
     */
    var createTab = function createTab(route) {
      var _ref5, _tabsConfig$fullPath$, _tabsConfig$fullPath, _ref6, _tabsConfig$fullPath$2, _tabsConfig$fullPath2, _route$meta3;
      var fullPath = route.fullPath;
      var path = route.path,
        name = route.name,
        _route$meta2 = route.meta,
        meta = _route$meta2 === void 0 ? {} : _route$meta2;
      var _meta$closeable = meta.closeable,
        closeable = _meta$closeable === void 0 ? true : _meta$closeable,
        _meta$cacheable2 = meta.cacheable,
        cacheable = _meta$cacheable2 === void 0 ? true : _meta$cacheable2,
        _meta$title = meta.title,
        title = _meta$title === void 0 ? name : _meta$title;
      return {
        key: route.fullPath,
        fullPath: route.fullPath,
        title: (_ref5 = (_tabsConfig$fullPath$ = (_tabsConfig$fullPath = tabsConfig[fullPath]) === null || _tabsConfig$fullPath === void 0 ? void 0 : _tabsConfig$fullPath['title']) !== null && _tabsConfig$fullPath$ !== void 0 ? _tabsConfig$fullPath$ : title) !== null && _ref5 !== void 0 ? _ref5 : path,
        closeable: closeable,
        cacheable: cacheable,
        loading: (_ref6 = (_tabsConfig$fullPath$2 = (_tabsConfig$fullPath2 = tabsConfig[fullPath]) === null || _tabsConfig$fullPath2 === void 0 ? void 0 : _tabsConfig$fullPath2['loading']) !== null && _tabsConfig$fullPath$2 !== void 0 ? _tabsConfig$fullPath$2 : (_route$meta3 = route.meta) === null || _route$meta3 === void 0 ? void 0 : _route$meta3.loading) !== null && _ref6 !== void 0 ? _ref6 : false,
        _is404Page: route.meta._is404Page
      };
    };
    /**
     * 添加页签
     * @param route
     */
    // eslint-disable-next-line complexity
    function addTab(route) {
      var fullPath = route.fullPath;
      var meta = route.meta,
        matched = route.matched;
      if (!fullPath || fullPath === props.basePath || meta !== null && meta !== void 0 && meta._basic_view || (matched === null || matched === void 0 ? void 0 : matched.length) === 0) {
        return;
      }
      current.value = fullPath !== props.basePath ? fullPath : undefined;
      var tab = tabList.find(function (item) {
        return item.fullPath === route.fullPath;
      });
      if (!tab) {
        pushTab(createTab(route));
      } else {
        var _route$meta5, _ref9, _tabsConfig$fullPath$5, _tabsConfig$fullPath5;
        var path = route.path,
          name = route.name,
          _route$meta4 = route.meta,
          _meta = _route$meta4 === void 0 ? {} : _route$meta4;
        var _meta$title2 = _meta.title,
          title = _meta$title2 === void 0 ? name : _meta$title2;
        if ((_route$meta5 = route.meta) !== null && _route$meta5 !== void 0 && _route$meta5._is404Page) {
          var _ref7, _tabsConfig$fullPath$3, _tabsConfig$fullPath3;
          tab._is404Page = true;
          tab.title = (_ref7 = (_tabsConfig$fullPath$3 = (_tabsConfig$fullPath3 = tabsConfig[fullPath]) === null || _tabsConfig$fullPath3 === void 0 ? void 0 : _tabsConfig$fullPath3['title']) !== null && _tabsConfig$fullPath$3 !== void 0 ? _tabsConfig$fullPath$3 : title) !== null && _ref7 !== void 0 ? _ref7 : path;
        } else if (tab._is404Page) {
          var _ref8, _tabsConfig$fullPath$4, _tabsConfig$fullPath4;
          tab.title = (_ref8 = (_tabsConfig$fullPath$4 = (_tabsConfig$fullPath4 = tabsConfig[fullPath]) === null || _tabsConfig$fullPath4 === void 0 ? void 0 : _tabsConfig$fullPath4['title']) !== null && _tabsConfig$fullPath$4 !== void 0 ? _tabsConfig$fullPath$4 : title) !== null && _ref8 !== void 0 ? _ref8 : path;
          delete tab._is404Page;
        }
        tab.loading = (_ref9 = (_tabsConfig$fullPath$5 = (_tabsConfig$fullPath5 = tabsConfig[fullPath]) === null || _tabsConfig$fullPath5 === void 0 ? void 0 : _tabsConfig$fullPath5['loading']) !== null && _tabsConfig$fullPath$5 !== void 0 ? _tabsConfig$fullPath$5 : _meta.loading) !== null && _ref9 !== void 0 ? _ref9 : false;
        resetTabPosition(tab);
      }
      dispatchChange();
    }
    /**
     * 选择右键菜单
     * @param key
     * @param target
     * @param meta
     */
    function onMenuSelect(key, target, meta) {
      var _contextItem$value;
      var fullPath = (_contextItem$value = contextItem.value) === null || _contextItem$value === void 0 ? void 0 : _contextItem$value.fullPath;
      if (fullPath) {
        switch (key) {
          case 'right':
            closeRight(fullPath);
            break;
          case 'left':
            closeLeft(fullPath);
            break;
          case 'others':
            closeOthers(fullPath);
            break;
          case 'refresh':
            refresh(fullPath);
            break;
        }
      }
    }
    /**
     * 点击右键
     * @param item
     */
    function onContext(item) {
      visible.value = true;
      contextItem.value = item;
    }
    /**
     * 关闭全部页签，清除缓存
     */
    function closeAll() {
      clearKeys.push.apply(clearKeys, _toConsumableArray(tabList.map(function (item) {
        return item.key;
      })));
      tabList.splice(0, tabList.length);
      router.push('tabs-view-empty');
    }
    /**
     * 关闭其它页签，同时清除缓存
     */
    function closeOthers(fullPath) {
      var clearTabs = tabList.filter(function (item) {
        return item.fullPath !== fullPath && item.closeable;
      });
      clearKeys.push.apply(clearKeys, _toConsumableArray(clearTabs.map(function (item) {
        return item.key;
      })));
      var tab = tabList.find(function (item) {
        return item.fullPath === fullPath;
      });
      if (tab) {
        tabList.splice(0, tabList.length, tab);
      } else {
        tabList.splice(0, tabList.length);
      }
      if (fullPath != current.value) {
        router.push(fullPath);
      }
    }
    /**
     * 关闭左侧页签，同时清除缓存
     */
    function closeLeft(fullPath) {
      var index = tabList.findIndex(function (item) {
        return item.fullPath === fullPath;
      });
      var clearTabs = tabList.filter(function (item, i) {
        return i < index && item.closeable;
      });
      clearKeys.push.apply(clearKeys, _toConsumableArray(clearTabs.map(function (item) {
        return item.key;
      })));
      tabList.splice.apply(tabList, [0, tabList.length].concat(_toConsumableArray(tabList.filter(function (item) {
        return !clearTabs.includes(item);
      }))));
      if (!tabList.some(function (item) {
        return item.fullPath === current.value;
      })) {
        router.push(fullPath);
      }
    }
    /**
     * 关闭右侧页签，同时清除缓存
     */
    function closeRight(fullPath) {
      var index = tabList.findIndex(function (item) {
        return item.fullPath === fullPath;
      });
      var clearTabs = tabList.filter(function (item, i) {
        return i > index && item.closeable;
      });
      clearKeys.push.apply(clearKeys, _toConsumableArray(clearTabs.map(function (item) {
        return item.key;
      })));
      tabList.splice.apply(tabList, [0, tabList.length].concat(_toConsumableArray(tabList.filter(function (item) {
        return !clearTabs.includes(item);
      }))));
      if (!tabList.some(function (item) {
        return item.fullPath === current.value;
      })) {
        router.push(fullPath);
      }
    }
    /**
     * 获取位置索引
     */
    function getPositionIndex(position) {
      var index = undefined;
      if (!isNaN(position)) {
        var number = parseInt(position);
        index = tabList.length > number ? number : tabList.length;
      } else if (_typeof(position) === 'object' || typeof position === 'string') {
        var positionPath = getFullPath(position);
        index = tabList.findIndex(function (item) {
          return item.fullPath === positionPath;
        });
        index = index === -1 ? undefined : index;
      }
      return index;
    }
    /**
     * 设置页签标题
     */
    function setTitle(fullPath, title) {
      if (title) {
        var target = {};
        var source = tabsConfig[fullPath];
        _extends(target, source, {
          title: title
        });
        tabsConfig[fullPath] = target;
        var tab = tabList.find(function (item) {
          return item.fullPath === fullPath;
        });
        tab && (tab.title = title);
      } else if (tabsConfig[fullPath]) {
        delete tabsConfig[fullPath].title;
      }
    }
    /**
     * 页签配置事件监听器
     */
    function configPageListener(event) {
      var _event$detail4;
      var _ref10 = (_event$detail4 = event === null || event === void 0 ? void 0 : event.detail) !== null && _event$detail4 !== void 0 ? _event$detail4 : {},
        route = _ref10.route,
        options = _ref10.options;
      var title = options.title,
        position = options.position,
        _options$replace2 = options.replace,
        replace = _options$replace2 === void 0 ? false : _options$replace2;
      var fullPath = getFullPath(route);
      setTitle(fullPath, title);
      setPosition(fullPath, position, replace);
    }
    /**
     * 设置页签状态为加载中...
     * @param event
     */
    function pageLoadingListener(event) {
      var _event$detail5;
      var _ref11 = (_event$detail5 = event === null || event === void 0 ? void 0 : event.detail) !== null && _event$detail5 !== void 0 ? _event$detail5 : {},
        route = _ref11.route,
        loading = _ref11.loading;
      var fullPath = getFullPath(route);
      var tab = tabList.find(function (item) {
        return item.fullPath === fullPath;
      });
      if (tab) {
        tab.loading = loading;
      } else {
        tabsConfig[fullPath].loading = loading;
      }
    }
    /**
     * 关闭全部页签
     * @param event
     */
    function pageCloseAllListener() {
      closeAll();
    }
    /**
     * 关闭其它页签
     * @param event
     */
    function pageCloseOthersListener(event) {
      var _event$detail6;
      var _ref12 = (_event$detail6 = event === null || event === void 0 ? void 0 : event.detail) !== null && _event$detail6 !== void 0 ? _event$detail6 : {},
        route = _ref12.route;
      var fullPath = getFullPath(route);
      closeOthers(fullPath);
    }
    /**
     * 设置页签位置
     */
    function setPosition(fullPath, position, replace) {
      var tab = tabList.find(function (item) {
        return item.fullPath === fullPath;
      });
      if (tab) {
        var before = tabList.findIndex(function (item) {
          return item.fullPath === fullPath;
        });
        var index = getPositionIndex(position);
        if (index !== undefined && before !== index) {
          if (replace && index < tabList.length) {
            closeByIndex(index);
            tabList.splice(index, 0, tab);
            tabList.splice(before, 1);
          } else {
            index = index >= tabList.length ? tabList.length - 1 : index;
            tabList.splice(before, 1);
            tabList.splice(index, 0, tab);
          }
        }
      }
    }
    /**
     * 浏览器刷新事件监听器
     */
    function unloadListener() {
      tabList.forEach(function (tab) {
        return tab.loading = false;
      });
      setSessionItem(sessionCacheKey.value, tabList);
    }
    /**
     * 从路由获取 fullPath
     */
    function getFullPath(route) {
      var _route = router.resolve(route);
      return _route && _route.fullPath;
    }
    /**
     * 触发页签变化事件
     */
    function dispatchChange() {
      var event = new CustomEvent('page:change', {
        detail: {
          pageList: _toConsumableArray(tabList)
        }
      });
      window.dispatchEvent(event);
    }
    onMounted(function () {
      loadRoutesConfig(router.getRoutes());
      loadSessionConfig();
      addTab(route);
      Object.entries(listenerConfig).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
          event = _ref14[0],
          listener = _ref14[1];
        window.addEventListener(event, listener);
      });
    });
    onBeforeUnmount(function () {
      Object.entries(listenerConfig).forEach(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
          event = _ref16[0],
          listener = _ref16[1];
        window.removeEventListener(event, listener);
      });
    });
    return function (_ctx, _cache) {
      var _component_router_view = resolveComponent("router-view");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(prefixCls), {
          affix: lock.value
        }]),
        ref: "div"
      }, [createVNode(unref(Contextmenu), {
        "menu-list": contextList,
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        onSelect: onMenuSelect
      }, null, 8 /* PROPS */, ["visible"]), lock.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass("".concat(unref(prefixCls), "-affix-head"))
      }, null, 2 /* CLASS */)) : createCommentVNode("v-if", true), createVNode(TabsViewHead, {
        class: normalizeClass({
          fixed: lock.value
        }),
        onRefresh: _cache[1] || (_cache[1] = function (item) {
          return refresh(item.key);
        }),
        onClose: _cache[2] || (_cache[2] = function (item) {
          return closeTab(item.key);
        }),
        lock: lock.value,
        "onUpdate:lock": _cache[3] || (_cache[3] = function ($event) {
          return lock.value = $event;
        }),
        onChange: _cache[4] || (_cache[4] = function (item) {
          return unref(router).push(item.fullPath);
        }),
        onContextmenu: onContext,
        "tab-list": tabList,
        active: current.value,
        "use-cache": __props.useCache
      }, createSlots({
        _: 2 /* DYNAMIC */
      }, [renderList(Object.keys(_ctx.$slots).filter(function (k) {
        return k !== 'footer';
      }), function (slot) {
        return {
          name: slot,
          fn: withCtx(function (bindings) {
            return [renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(bindings)))];
          })
        };
      })]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "lock", "tab-list", "active", "use-cache"]), createElementVNode("div", {
        class: normalizeClass(["".concat(unref(prefixCls), "-content"), {
          empty: tabList.length === 0
        }])
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-content-main"))
      }, [createVNode(_component_router_view, null, {
        default: withCtx(function (_ref17) {
          var _unref$meta$cacheable2, _unref$meta2, _currTab$value2, _currTab$value3;
          var Component = _ref17.Component;
          return [createVNode(unref(TabsKeepAlive), {
            "clear-keys": clearKeys,
            "exclude-keys": excludeKeys
          }, {
            default: withCtx(function () {
              var _unref$meta$cacheable, _unref$meta, _currTab$value;
              return [!reloading.value && __props.useCache && ((_unref$meta$cacheable = (_unref$meta = unref(route).meta) === null || _unref$meta === void 0 ? void 0 : _unref$meta.cacheable) !== null && _unref$meta$cacheable !== void 0 ? _unref$meta$cacheable : true) && !((_currTab$value = currTab.value) !== null && _currTab$value !== void 0 && _currTab$value.loading) ? (openBlock(), createBlock(resolveDynamicComponent(Component), {
                key: unref(route).fullPath
              })) : createCommentVNode("v-if", true)];
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["clear-keys", "exclude-keys"]), !reloading.value && (!__props.useCache || !((_unref$meta$cacheable2 = (_unref$meta2 = unref(route).meta) === null || _unref$meta2 === void 0 ? void 0 : _unref$meta2.cacheable) !== null && _unref$meta$cacheable2 !== void 0 ? _unref$meta$cacheable2 : true)) && !((_currTab$value2 = currTab.value) !== null && _currTab$value2 !== void 0 && _currTab$value2.loading) ? (openBlock(), createBlock(resolveDynamicComponent(Component), {
            key: unref(route).fullPath
          })) : createCommentVNode("v-if", true), (_currTab$value3 = currTab.value) !== null && _currTab$value3 !== void 0 && _currTab$value3.loading ? (openBlock(), createElementBlock("div", _hoisted_1, "加载中...")) : createCommentVNode("v-if", true)];
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */), createElementVNode("div", {
        class: normalizeClass(["".concat(unref(prefixCls), "-content-footer"), {
          empty: !_ctx.$slots.footer
        }])
      }, [renderSlot(_ctx.$slots, "footer")], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var TabsView = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/tabs-view/TabsView.js"]]);
export { TabsView as default };